export default "__VITE_ASSET__uKMUxp3E__"